export function clearAudioTracks(
  videoNode: HTMLVideoElement & {
    audioTracks: [{ enabled: boolean }]
  }
) {
  if (videoNode && videoNode.audioTracks) {
    for (const track of videoNode.audioTracks) {
      track.enabled = false
    }
  }
}
